import React, { useState } from "react"
import "../styles/global.scss"
import "../styles/home.scss"
import Hero from "../components/Hero"
import "../styles/flaticon/flaticon.css"
import MainLayout from "../layouts/MainLayout"
import HomeTechsCarousel from "../components/HomeTechsCarousel"
import HomeCoreValuesTimeline from "../components/HomeCoreValuesTimeline"
import HomeServices from "../components/HomeServices"
import HomeContactForm from "../components/HomeContactForm"
import HomePortfolioCarousel from "../components/HomePortfolioCarousel"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import { Heading2 } from "../components/utils/Typography"
import AgainGetQuote from "../components/AgainGetQuote"

export default function Home() {
  const [toastObj, setToastObj] = useState(null)

  return (
    <div className="home">
      <MainLayout>
        <Hero />
        {/* services */}
        <div className="mb-5">
          <Heading2
            heading="Our Services"
            subheading="we work with you, not for you"
          />
        </div>
        <HomeServices />
        <div className="container py-2 pt-4 d-flex justify-content-center justify-content-md-end align-items-center">
          <AniLink
            paintDrip
            hex="#551864"
            to="/services"
            className="viewAllServicesBtn px-4 fs-5 fw-bold d-flex justify-content-start align-items-center px-2"
          >
            All Services <i className="bi bi-arrow-right-short fs-1"></i>
          </AniLink>
        </div>
        <br />

        {/* portfolio */}
        <div className="my-5 py-5" id="portfolio">
          <Heading2
            heading="Our Portfolio"
            subheading="development, out of the box"
          />
          <HomePortfolioCarousel />
        </div>
        <br />
        <br />
        {/* team */}
        <div style={{ backgroundColor: "#fffefc" }}>
          <Heading2
            heading="Our Team"
            subheading="dedicated team, expert developers"
          />
          <div className="container">
            <div className="row flex-column-reverse flex-md-row align-items-center">
              <div className="col-12 col-md-6 fs-5 d-flex flex-column justify-content-start align-items-start">
                At Codefumes, our priority is to add maximum value to the
                project, keeping that in mind, we've formed a team of highly
                skilled people from different domains having expertise in their
                work to ensure that whatever we deliver, it must be a quality
                product.
                <div className="row w-100 mt-1">
                  <div className="col-12 d-flex justify-content-center justify-content-md-start">
                    {/* <AniLink
                      paintDrip
                      hex="#551864"
                      to="/team"
                      className="viewTeamBtn px-4 fs-5 fw-bold d-flex justify-content-start align-items-center mt-4"
                    >
                      <span>Team behind the magic</span>
                      <i className="ms-1 bi bi-arrow-right-short fs-1"></i>
                    </AniLink> */}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-end align-items-start">
                {/* <AniLink paintDrip hex="#551864" to="/team">
                  <img
                    loading="lazy"
                    src="images/team_work.webp"
                    alt=""
                    className="img-fluid"
                  />
                </AniLink> */}
              </div>
            </div>
          </div>
        </div>
        <br />

        {/* lets talk */}
        <div className="py-5 mt-5 letsTalk" id="letstalk">
          <Heading2
            heading="Contact"
            subheading="get in touch with us"
            darkBgFlag={true}
          />
          <div className="container pt-4">
            <div className="row flex-column-reverse flex-md-row">
              <div className="col-12 col-md-6" id="letsTalk">
                <HomeContactForm setToastObj={setToastObj} />
              </div>
              <div className="col-12 col-md-6 d-flex flex-column justify-content-start align-items-center">
                <div className="display-2 text-white fw-bold my-4">
                  Let's Talk
                </div>
                <img
                  loading="lazy"
                  src="images/paper_plane.webp"
                  alt=""
                  className="img-fluid"
                  width="250px"
                />
              </div>
            </div>
          </div>
        </div>

        {/* technologies carousel */}
        <div className="my-5 pt-5">
          <Heading2
            heading="Our Tech Stack"
            subheading="latest technologies we use"
          />
        </div>
        <HomeTechsCarousel />

        {/* core values */}
        <div style={{ backgroundColor: "#fffefc" }}>
          <Heading2
            heading="Our Core Values"
            subheading="core principle that we follow"
          />
          <div className="container">
            <div className="row flex-column-reverse flex-md-row align-items-center">
              <div className="col-12 col-md-6 fs-5 d-flex flex-column justify-content-start align-items-start">
                <p>
                  At Codefumes, our priority is to
                  <span className="text-purple fw-bold"> innovate </span>
                  maximum value to the project. Keeping that in mind, we always
                  tend to{" "}
                  <span className="text-purple fw-bold"> experiment </span> with
                  latest cutting-edge technologies for each project to develop
                  most efficient solution with respect to time and space that
                  fulfill the project requirements and can scale with the
                  everchanging tech trends after{" "}
                  <span className="text-purple fw-bold"> deployment </span>.
                </p>
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-end align-items-start">
                <AniLink paintDrip hex="#551864" to="/team">
                  <img
                    loading="lazy"
                    src="images/team_work2.webp"
                    alt=""
                    className="img-fluid"
                  />
                </AniLink>
              </div>
            </div>
          </div>
          <HomeCoreValuesTimeline />
        </div>

        <AgainGetQuote />

        {/* toast alert */}
        {toastObj && (
          <div
            className="toast myToastBottomLeft"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="toast-header">
              <img
                src="favicon.ico"
                className="rounded me-2"
                alt="toast-logo"
                width="22px"
              />
              <strong className="me-auto">{toastObj.heading}</strong>
              <small>{toastObj.timePassed}</small>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="toast"
                aria-label="Close"
                onClick={setToastObj(null)}
              ></button>
            </div>
            <div className="toast-body">{toastObj.desc}</div>
          </div>
        )}
      </MainLayout>
    </div>
  )
}
